import { combineReducers } from 'redux'
import { authReducers } from './authReducers'
import { chatReducers } from './chatReducers'

export default combineReducers({
  auth: authReducers,
  chat: chatReducers,
})
